import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading } from "components/misc/Headings.js";

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const GreenLink = tw.a`text-brand5 hocus:text-brand4`;
const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-8 md:mt-0`,
  props.textOnLeft ? tw`md:mr-8 lg:mr-16 md:order-first` : tw`md:ml-8 lg:ml-16 md:order-last`
]);
const TextContent = tw.div`lg:py-8`;

const Heading = tw(SectionHeading)`text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Meta = tw.p`text-center md:text-left text-sm md:text-base font-medium text-brand4 mt-2 mb-4`;
const Description = tw.p`text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-brand5 mt-4`;
const SubHeading = tw.h2`text-center md:text-left text-xl md:text-2xl font-bold text-brand5 mt-10 mb-2`;
const List = tw.ul`mt-2 mb-2 pl-5 list-disc text-center md:text-left`;
const ListItem = tw.li`text-sm md:text-base lg:text-lg font-medium leading-relaxed text-brand5 mt-2`;

const TermsOfService = ({textOnLeft = false}) => {
  return (
    <div id="nav-terms">
      <Container>
        <TwoColumn>
          <TextColumn textOnLeft={textOnLeft}>
            <TextContent>
              <Heading>Terms of Service</Heading>
              <Meta>Last updated: 6 October 2026</Meta>

              <Description>
                Welcome to Clarebrand Village Hall. By using this website you agree to these terms
                and conditions. If you do not agree, please do not use the site or submit our forms.
              </Description>

              <SubHeading>1. About us</SubHeading>
              <Description>
                Clarebrand Village Hall is a community hall in Clarebrand, Dumfries and Galloway
                (DG7 3AH), operated by the Clarebrand Village Hall Committee (Scottish Charity
                number SC008463). This website provides information about the hall, hiring and
                booking options, community updates, and ways to get in touch or donate.
              </Description>

              <SubHeading>2. Use of this website</SubHeading>
              <List>
                <ListItem>You may browse the site for personal or community information purposes.</ListItem>
                <ListItem>Do not misuse the site, attempt to disrupt it, or submit spam or abusive content.</ListItem>
                <ListItem>
                  External links (for example Facebook, payment providers, or other third-party
                  services) are operated by those parties and have their own terms and privacy practices.
                </ListItem>
              </List>

              <SubHeading>3. Hall hire and bookings</SubHeading>
              <List>
                <ListItem>
                  Submitting a booking or contact form does not by itself create a confirmed hire.
                  Availability, pricing, and conditions are confirmed separately by the hall
                  committee (for example by email or other reply).
                </ListItem>
                <ListItem>
                  Published rates (such as morning, afternoon, or evening blocks) are a guide and
                  may change. Regular clubs, meetings, or larger events may be offered different
                  rates by arrangement.
                </ListItem>
                <ListItem>
                  You are responsible for using the hall safely and lawfully, and for following any
                  hire conditions, house rules, or insurance requirements we communicate when a
                  booking is agreed.
                </ListItem>
                <ListItem>
                  Free local advertising for your event via our site or other channels, where
                  offered, is discretionary and does not form part of a hire contract unless
                  expressly agreed.
                </ListItem>
              </List>

              <SubHeading>4. Donations and third-party payments</SubHeading>
              <Description>
                Donations or payments may be handled by third-party platforms (for example PayPal).
                Any payment, refund, or donation terms are those of the relevant provider, in
                addition to any instructions we give about supporting the hall.
              </Description>

              <SubHeading>5. Privacy and cookies</SubHeading>
              <Description>
                How we collect, use, and look after personal information — including contact and
                booking forms, the mailing list, and cookies — is set out in our{" "}
                <GreenLink href="/privacy">Privacy and Cookie Policy</GreenLink>.
              </Description>

              <SubHeading>6. Intellectual property</SubHeading>
              <Description>
                Site content (including branding, copy, and imagery we publish) belongs to
                Clarebrand Village Hall Committee or its licensors. You may not copy or reuse it
                commercially without permission. Photographs and third-party materials remain
                subject to their own rights.
              </Description>

              <SubHeading>7. Disclaimer</SubHeading>
              <Description>
                The site is provided as-is for information about the hall, hire options, and
                community activity. We try to keep details accurate, but opening times, rates,
                availability, and external links can change. To the fullest extent permitted by
                law, Clarebrand Village Hall Committee is not liable for loss arising from use of
                the site or reliance on its contents.
              </Description>

              <SubHeading>8. Changes</SubHeading>
              <Description>
                We may update these terms from time to time. The “Last updated” date at the top of
                this page will change when we do. Continued use of the site after changes means you
                accept the updated terms.
              </Description>

              <SubHeading>9. Contact</SubHeading>
              <Description>
                Questions about these terms can be sent through our{" "}
                <GreenLink href="/book">contact form</GreenLink>. For privacy requests, see the{" "}
                <GreenLink href="/privacy">Privacy and Cookie Policy</GreenLink>.
              </Description>
              <Description>
                Clarebrand Village Hall Committee · Clarebrand · DG7 3AH · Scottish Charity SC008463
              </Description>
            </TextContent>
          </TextColumn>
        </TwoColumn>
      </Container>
    </div>
  );
};

export default TermsOfService
